import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 36 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

export function SectionHeading({ chapter, title, subtitle }) {
  return (
    <Reveal className="mb-8 text-center">
      {chapter && (
        <span className="mb-2 block text-[11px] font-semibold uppercase tracking-[0.28em] text-[var(--accent)]">
          {chapter}
        </span>
      )}
      <h2 className="text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl">
        {title}
      </h2>
      {subtitle && (
        <p className="mx-auto mt-3 max-w-md text-[15px] font-medium leading-relaxed text-[var(--ink-soft)]">
          {subtitle}
        </p>
      )}
    </Reveal>
  );
}
